import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import ReactModal from 'react-modal';
import PageError from './pages/Errors/PageError';
import PageNotFound from './pages/Errors/PageNotFound';
import { routeTree } from './routeTree.gen';
import { queryClient } from './utils/apiClient';

const router = createRouter({
  defaultNotFoundComponent: PageNotFound,
  defaultErrorComponent: PageError,
  routeTree
});

// For runtime type safety of routes
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
ReactModal.setAppElement('#root');
export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <TanStackRouterDevtools router={router} />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
